
<ng-container *ngIf="!subValue; else withSubValue;">
	<span [ngClass]="[
			styles.value,
			getThresholdRangeClass(+value)
		]" [countUp]="value" [countUpOptions]="{
			decimal: localeDecimalSymbol,
			decimalPlaces: decimalPlaces,
			duration: .4,
			separator: localeGroupSymbol,
			suffix: suffix
		}" [reanimateOnClick]="false">
	</span>

	<span class="glyphicons" [ngClass]="[
			styles.icon,
			deltaIconCssClass
		]">
	</span>
</ng-container>

<ng-template #withSubValue>
	<div layout="row">
		<div flex="fill" [ngClass]="styles.item">
			<div>
				{{ valueLabel }}
			</div>
			<div class="padding-top-5" [ngClass]="[
					styles.itemValue
				]" [countUp]="value" [countUpOptions]="{
					decimal: localeDecimalSymbol,
					decimalPlaces: decimalPlaces,
					duration: .4,
					separator: localeGroupSymbol,
					suffix: suffix
				}" [reanimateOnClick]="false">
			</div>
			<span class="glyphicons" [ngClass]="[
					styles.itemIndicator,
					deltaIconCssClass
				]">
			</span>
		</div>
		<div flex="fill" [ngClass]="styles.item">
			<div>
				{{ subValueLabel }}
			</div>
			<div class="padding-top-5" [ngClass]="[
					styles.itemValue
				]" [countUp]="subValue" [countUpOptions]="{
					decimal: localeDecimalSymbol,
					decimalPlaces: decimalPlaces,
					duration: .4,
					separator: localeGroupSymbol,
					suffix: suffix
				}" [reanimateOnClick]="false">
			</div>
			<span class="glyphicons" [ngClass]="[
					styles.itemIndicator,
					subValueDeltaIconCssClass
				]">
			</span>
		</div>
	</div>
</ng-template>